// ViewPayroll.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../url";
import "../Styling/viewPayroll.css"; 
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
export default function ViewPostedPayrollNew() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const navigate=useNavigate();
const [orgId, setOrgId] = useState("");
const [compCode, setCompCode] = useState("");
const [yearVal, setYearVal] = useState("");
const [monthName, setMonthName] = useState("");
const monthMap = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

  useEffect(() => {
  if (!id) return;

  const organisationId = id.substring(0, 4);
  const companyCode = id.substring(4, 8);
  const year = id.substring(8, 12);
  const month = id.substring(12, 14);

  // 🔥 Save values into state
  setOrgId(organisationId);
  setCompCode(companyCode);
  setYearVal(year);
  setMonthName(monthMap[month] || "Invalid");

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await axios.get(
        `${Base_URL}/SalaryProcess/GetPayrollData/id?id=${id}`
      );
      setRows(resp.data || []);
    } catch (err) {
      console.error("Failed to fetch payroll data:", err);
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [id]);


  const toNum = (v) => {
    if (v === null || v === undefined) return 0;
    const n = Number(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  const summary = rows.reduce(
    (acc, item) => {
      const p = item.payroll || {};
      const s = item.salary || {};

      acc.sumNetPayable += toNum(p.net)||toNum(p.proRatedSalary);
      acc.sumBase += toNum(p.baseInHand);
      acc.sumHra += toNum(p.hra);
      acc.sumOther += toNum(p.otherAllowance);
      acc.sumDeductions += toNum(p.totalDeductions);
      acc.sumCalcBasic += toNum(p.basicPlusDa); // ✅ FIX ADDED

      acc.sumOrigBasic += toNum(s.basicPlusDa);
      acc.sumOrigHra += toNum(s.hra);
      acc.sumOrigSpl += toNum(s.splAll ?? s.other);

      acc.sumGross += toNum(p.proRatedSalary) 
  acc.sumMa+=toNum(s.ma)
      acc.sumTa+=toNum(s.ta)
      acc.sumCalMA+=toNum(p.ma)
      acc.sumCalTA+=toNum(p.ta)
      acc.gross+=toNum(p.gross)
      return acc;
    },
    {
      sumNetPayable: 0,
      sumBase: 0,
      sumHra: 0,
      sumOther: 0,
      sumDeductions: 0,
      sumGross: 0,

      sumCalcBasic: 0, // ✅ INITIALIZE
      sumOrigBasic: 0,
      sumOrigHra: 0,
      sumOrigSpl: 0,
      sumTa:0,
      sumMa:0,
      sumCalTA:0,
      sumCalMA:0,
      gross:0
    }
  );

  const fmtCurrency = (n) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);

    // ---------------------------------------
// 📌 Excel Export Function
// ---------------------------------------
const handleExportToExcel = () => {
  const XLSX = require("xlsx");

  const excelData = rows.map((item) => {
    const p = item.payroll || {};
    const s = item.salary || {};
    const origSpl = s.splAll ?? s.other ?? 0;

    return {
      "Resource": item.resource,
      "Resource ID": p.resourceid,

      "Orig Basic + DA": toNum(s.basicPlusDa),
      "Orig HRA": toNum(s.hra),
      "Orig Special Allowance": toNum(origSpl),
      "Orig MA": toNum(s.ma),
      "Orig TA": toNum(s.ta),
      "Orig Gross": toNum(p.gross) || toNum(s.gross),

      "Calendar Days": p.calendarDays,
      "Salary Days": p.salaryDays,

      "Calculated Basic + DA": toNum(p.basicPlusDa),
      "Calculated HRA": toNum(p.hra),
      "MA": toNum(p.ma),
      "TA": toNum(p.ta),
      "Special Allowance": toNum(p.otherAllowance),
      "Gross": toNum(p.proRatedSalary),
      "Total Deductions": toNum(p.totalDeductions),
      "Net Payable": toNum(p.net) || toNum(p.proRatedSalary),
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");

  XLSX.writeFile(workbook, `Payroll_${yearVal}_${monthName}.xlsx`);
};


  // --- New: handler to build payload and console.log it ---
  const handleSendNetPayables = async() => {
    // Build items array from rows
    const items = rows.map((item) => {
      const p = item.payroll || {};
      // choose resource id field — try payroll.resourceid, fallback to item.resourceId or item.resource
      const resourceId =
        p.resourceid ??
        item.resourceId ??
        item.resource ??
        null;

      return {
        resourceId,
        payrollId: p.payrollId ?? null,
        netPayable: toNum(p.netPayable),
      };
    });

    const payload = {
      runId: id, // the id from useParams
      items,
    };

    console.log("Send Net Payables payload:", payload);
    const res=await axios.post(`${Base_URL}/SalaryProcess/PostPayroll`,payload)
    if(res.data)
    {
        toast.success(res.data);
        navigate('/hr-dashboard');
    }
    else 
    {
        toast.error("Error Posting Payroll");
    }
    
  };

  if (loading) {
    return (
      <div>
        <h2>View Payroll</h2>
        <p>Loading payroll data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h2>View Payroll</h2>
        <div style={{ color: "red" }}>Error: {String(error)}</div>
      </div>
    );
  }

  return (
    <div className=" payroll-container">
      {/* Heading */}
      <h2 className="text-2xl font-semibold">Payroll For</h2>
      <div className="mb-4 text-gray-700 payroll-details">
  <p className="summary-card2"><b >Organisation ID:</b> {orgId}</p>
  <p className="summary-card2"><b>Company Code:</b> {compCode}</p>
  <p className="summary-card2"><b>Year:</b> {yearVal}</p>
  <p className="summary-card2"><b>Month:</b> {monthName}</p>
</div>
      <div className="flex items-center justify-between mb-4">
        


        {/* NEW BUTTON */}
      </div>

      {/* Summary (card boxes) - uses external CSS */}
      <div className="summary-container">
        <div className="summary-card">
          <div className="summary-label">Total Net Payable</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumNetPayable)}</div>
        </div>

        {/* Now shows Total Gross (from payroll.gross or fallback) */}
        <div className="summary-card">
          <div className="summary-label">Total Gross</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumGross)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total HRA</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumHra)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Special Allowance</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOther)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total Deductions</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumDeductions)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Orig Basic + DA</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigBasic)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Orig HRA</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigHra)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Orig Special Allow.</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigSpl)}</div>
        </div>
      </div>
<div className="flex justify-end mb-4">
  <button
    onClick={handleExportToExcel}
    className="px-5 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition-colors duration-300"
  >
    📥 Download Excel
  </button>
</div>


      {/* Table */}
      <div className="overflow-x-auto bg-white rounded shadow scroll-payroll-div">
        <table className="min-w-full divide-y">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Resource</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Resource ID</th>

              {/* CALCULATED FIRST: BASE IN HAND */}

              {/* ORIGINAL SALARY */}
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Orig Basic + DA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Orig HRA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Orig Special Allow.</th>
               <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Orig MA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Orig TA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Gross</th>

              {/* CALCULATED PAYROLL AFTER */}
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Calendar Days</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Salary Days</th>

              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Basic + DA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">HRA</th>
                <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">MA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">TA</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Special Allowance</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Gross</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Total Deductions</th>
              <th className="px-3 py-3 text-right text-sm font-medium text-gray-700">Net Payable</th>
            </tr>
          </thead>
          
          <tbody className="divide-y">
            {rows.map((item, idx) => {
              const p = item.payroll || {};
              const s = item.salary || {};
              const origSpl = s.splAll ?? s.other ?? 0;

              return (
                <tr key={p.payrollId ?? idx}>
                  <td className="px-3 py-3 text-sm">{item.resource}</td>
                  <td className="px-3 py-3 text-sm">{p.resourceid}</td>

                  {/* CALCULATED FIRST: BASE */}

                  {/* ORIGINAL SALARY */}
                 <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.basicPlusDa))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.hra))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(origSpl))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.ma))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.ta))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.gross) || toNum(p.proRatedSalary) || toNum(p.baseInHand))}</td>
                
                  {/* CALCULATED */}
                 <td className="px-2 py-2 text-sm">{p.calendarDays ?? "-"}</td>
                  <td className="px-2 py-2 text-sm">{p.salaryDays ?? "-"}</td>

                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.basicPlusDa))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.hra))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.ma))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.ta))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.otherAllowance))}</td>
                <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.proRatedSalary))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.totalDeductions))}</td>
                   <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.net) || toNum(p.proRatedSalary) )}</td>
                </tr>
              );
            })}
          </tbody>

          <tfoot className="bg-gray-50">
            <tr>
              <td className="px-3 py-3 text-sm font-medium">Totals</td>
              <td />

              {/* Original */}
             <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOrigBasic)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOrigHra)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOrigSpl)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumMa)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumTa)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.gross)}</td>

              <td />
              <td />

              {/* Calculated */}
           <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumCalcBasic)}</td> {/* ✅ FIX */}
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumHra)}</td>
                <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumCalMA)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumCalTA)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOther)}</td>
           <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumGross)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumDeductions)}</td>
              
                <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumNetPayable)||fmtCurrency(summary.sumGross)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
